export default function categoryAxis(
   userTheme,
   axis,
   axisConfig,
   hideLabels,
   onZero,
) {
   const themeColor = userTheme === "Dark" ? "#E6E6E6" : "#171717";

   if (!axisConfig) {
      return null;
   }
   //Set label width
   let labelWidth = 4; //(padding/boorders?)

   if (axisConfig?.labelDisplayLength) {
      labelWidth = labelWidth + axisConfig.labelDisplayLength * 7; //character is approx 7 px. wide
   } else {
      labelWidth = labelWidth + 8 * 7; //8 chars is default for categorical axis
   }

   let newCategoryAxis = {
      type: "category",
      name: axisConfig.name,
      nameLocation: "middle",
      nameGap: axis === "y" ? labelWidth + 10 : 25,
      nameTextStyle: {
         color: themeColor,
      },
      axisLine: {
         lineStyle: {
            color: themeColor,
         },
         onZero: onZero,
      },
      splitLine: {
         lineStyle: {
            color: ["#C4C4C4", "#B6B8B9"],
         },
      },
      alignTicks: true,
      axisTick: {
         alignWithLabel: true,
         show: !onZero,
      },
      hideOverlap: true,
      axisLabel: {
         hideOverlap: true,
         width: axis === "y" ? labelWidth : "",
         overflow: axis === "y" ? "truncate" : "none",
         color: themeColor,
      },
   };

   if (hideLabels) {
      newCategoryAxis = {
         ...newCategoryAxis,
         axisTick: {
            show: false,
         },
         axisLabel: {
            show: false,
         },
         nameTextStyle: {
            fontSize: 0,
         },
         nameGap: 0,
      };
   }

   //Desktop inverts the categorical values on the y-axis
   if (axis === "y") {
      newCategoryAxis = {
         ...newCategoryAxis,
         inverse: true,
      };
   }

   return newCategoryAxis;
}
